import(/* webpackMode: "eager" */ "/workspace/apps/dealerportal/app/[locale]/[clientId]/[platform]/[contentPage]/error.tsx");
